import axios, { AxiosResponse } from "axios";
import { convertToPageable, downloadFileWithPresignedUrl, extractData, handleResponse } from "helpers/apiResponseHelper";
import { SynchronizationData, SynchronizationErrorData, SynchronizationType } from "models/syncronization";
import { apiService } from "services/api.service";

async function findInvoices(pageRequest: any) {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin`, {
      params: pageRequest
  }).then(handleResponse).then(convertToPageable);
}

async function createInvoiceForAgreement(agreementId: number) {
  return axios.post(apiService.getApiUrl() + `/electricity/invoices/admin/agreement/${agreementId}`, {})
    .then(handleResponse).then(extractData);
}

async function createInvoices(isPerson : boolean) {
  return axios.post(apiService.getApiUrl() + `/electricity/invoices/admin?isPerson=${isPerson}`, {});
}

async function findInvoicesForAgreement(contractNumber: string) {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin/agreement/${contractNumber}`)
    .then(handleResponse).then(extractData);
}

async function getSynchronizationStatus(
  type: SynchronizationType
) : Promise<SynchronizationData> {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin/sync/status/type/${type}`)
    .then(handleResponse).then(extractData);
}

async function findLatestSynchronizationErrors(
  type: SynchronizationType
) : Promise<SynchronizationErrorData[]> {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin/sync/errors/latest/type/${type}`)
    .then(handleResponse).then(extractData);
}

async function getInvoiceFileWithDownload(invoiceId: number, filename: string) {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin/${invoiceId}/file?downloadAs=${filename}`)
    .then(handleResponse).then((res) => downloadFileWithPresignedUrl(res.data));
}

async function getInvoiceFile(invoiceId: number) : Promise<AxiosResponse<string>> {
  return axios.get(apiService.getApiUrl() + `/electricity/invoices/admin/${invoiceId}/file`)
    .then(handleResponse);
}

async function generateInvoicesReport(email: string) {
  return axios.post(apiService.getApiUrl() + `/electricity/invoices/admin/report?email=${email}`);
}

export const ElectricityInvoicesService = {
  findInvoices,
  createInvoiceForAgreement,
  findInvoicesForAgreement,
  createInvoices,
  getSynchronizationStatus,
  findLatestSynchronizationErrors,
  getInvoiceFileWithDownload,
  getInvoiceFile,
  generateInvoicesReport
};